module.exports = __webpack_public_path__ + "static/Background-scot-3.6ca86142.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Background-scot-3.jpg
// module id = 476
// module chunks = 153228935106781